import { Box, Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import MHButton from "../Common/Button/MHButton";
import UpcomingEventCard from "./UpcomingEventCard";
import { useHistory } from "react-router-dom";
import { ResourcesData } from "./EventGlance";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase";
import dayjs from "dayjs";
import AnimatedLoaderText, {
  dotPulse,
  fadeIn,
} from "../Common/Loading/AnimatedLoaderText";

// const events = [
//   {
//     date: "AUG 10TH",
//     title: "Parents & Guidiance Inclusive Program",
//     tags: " Parenting, Wellbeing",
//     imageUrl:
//       "https://mh-resources-production.s3.us-west-1.amazonaws.com/hero-caf-new.jpeg",
//   },
//   {
//     date: "OCT 10TH",
//     title: "Care in the work place",
//     tags: " Care, Wellbeing",
//     imageUrl:
//       "https://mh-resources-production.s3.us-west-1.amazonaws.com/hero-caf-new.jpeg",
//   },
//   {
//     date: "AUG 16TH",
//     title: "Parents & Guidiance Inclusive Program",
//     tags: " Parenting, Wellbeing",
//     imageUrl:
//       "https://mh-resources-production.s3.us-west-1.amazonaws.com/hero-caf-new.jpeg",
//   },
//   {
//     date: "OCT 16TH",
//     title: "Care in the work place",
//     tags: " Care, Wellbeing",
//     imageUrl:
//       "https://mh-resources-production.s3.us-west-1.amazonaws.com/hero-caf-new.jpeg",
//   },
// ];

const UpcomingEvents = () => {
  const history = useHistory(); // ← add
  const [summitData, setSummitData] = useState<ResourcesData[]>([]); // ← fix
  const fewEvents = summitData.slice(0, 2);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const collectionRef = collection(db, "caf-summit-list");
        const querySnapshot = await getDocs(
          query(collectionRef, orderBy("slug", "asc")),
        );

        const data = querySnapshot.docs.map((doc) => ({
          ...(doc.data() as ResourcesData), // ← fix
        }));

        setSummitData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  if (!summitData)
    return <AnimatedLoaderText text="Fetching data, please wait..." />;

  // console.log("fewEvents", fewEvents);
  return (
    <React.Fragment>
      <Grid
        container
        sx={{
          borderRadius: "12px",
          justifyContent: "center",
          alignItems: "center",
          height: { xs: "100%", sm: "100%", md: "621px" },
          overflow: "hidden",
          //   bgcolor: "#184049",
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={5.8}
          display="flex"
          justifyContent="center"
        >
          <Box
            className="card-bg"
            sx={{
              borderRadius: 5,
              backgroundImage: `url("https://mh-resources-production.s3.us-west-1.amazonaws.com/eventCaf.png")`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              transition: "transform 0.5s ease",
              width: { xs: "400px", sm: "600px" },
              height: { xs: "400px", sm: "600px" },
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={5.8}
          p={{ xs: 2, sm: 4 }}
          display="block"
          justifyContent="center"
          bgcolor={"194049"}
        >
          <Typography
            variant="h2"
            fontSize={{ xs: "28px", sm: "34px", md: "40px" }}
            lineHeight={{ xs: "103%", sm: "105.5%" }}
            letterSpacing="-0.05em"
            align="center"
            className="py-4"
          >
            Upcoming Events
          </Typography>
          <Divider sx={{ my: 2, width: "90%" }} />
          <Box display="flex" flexDirection="column" alignItems="center">
            {fewEvents.length > 0 ? (
              fewEvents.map((event, i) => (
                <UpcomingEventCard
                  key={i}
                  date={dayjs(event.eventDate).format("MMMM D")}
                  title={event.title}
                  tags={event.venue}
                  imageUrl={event.imgSrc}
                  onClick={() => history.push(`/events/${event.slug}`)}
                />
              ))
            ) : (
              <>
                <Typography
                  variant="subtitle1"
                  fontSize={{ xs: "18px", sm: "20px", md: "20px" }}
                  width={{ xs: "70%", sm: "100%", md: "100%" }}
                  fontStyle="italic"
                  className="text-center mx-auto"
                  sx={{
                    animation: `${fadeIn} 1.2s ease-in-out infinite alternate`,
                  }}
                >
                  New events coming soon
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "6px",
                    mt: 1,
                  }}
                >
                  {[0, 1, 2].map((i) => (
                    <Box
                      key={i}
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: "primary.main",
                        animation: `${dotPulse} 1.4s ease-in-out infinite`,
                        animationDelay: `${i * 0.2}s`,
                      }}
                    />
                  ))}
                </Box>
              </>
            )}
          </Box>

          <Box display="flex" justifyContent="center" mt={3}>
            <MHButton
              onClick={() => history.push(`/events`)}
              sx={{
                color: "#fff",
                backgroundColor: "primary.main",
                borderRadius: "36px",
                "&:hover": {
                  backgroundColor: "#fff",
                  color: "primary.main",
                  borderColor: "primary.main",
                  border: 2,
                },
              }}
              className="w-fit md:w-[170px] h-8 md:h-[40px] font-areaExt text-[10px] md:text-xs"
            >
              See All Events
            </MHButton>
          </Box>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default UpcomingEvents;
